import URLS from '@/store/urls';
import notificationWithIcon from '@/utils/notification';
import apiCall from '@/store/apiCall';
import types from './types';

const actions = {
  async getWizard({ commit }, payload) {
    try {
      commit(types.GET_WIZARD_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.wizardBadges}?product=${payload}`,
        isToken: true,
      });
      commit(types.GET_WIZARD_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_WIZARD_FAILURE, message);
    }
  },
  async getWizardSteps({ commit }, payload) {
    try {
      commit(types.GET_WIZARD_START);
      const { data: { data } } = await apiCall({
        type: 'GET',
        url: `${URLS.wizardSteps}?product=${payload}`,
        isToken: true,
      });
      commit(types.GET_WIZARD_STEPS_SUCCESS, data);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
      commit(types.GET_WIZARD_FAILURE, message);
    }
  },
  async updateWizardCardsOrder({ dispatch }, payload) {
    try {
      const { newSections, type } = payload;
      await apiCall({
        type: 'PUT',
        url: URLS.wizardOrderSection,
        body: newSections,
        isToken: true,
      });
      notificationWithIcon('success', 'Wizard cards order changed');
      dispatch('getWizardSteps', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async updateWizardCard({ dispatch }, payload) {
    try {
      const { newSection, type, deleteImages } = payload;
      const { images, ...section } = newSection;

      if (deleteImages.length) {
        await apiCall({
          type: 'PATCH',
          url: `${URLS.wizardOrderSection}s/${section.id}/images`,
          body: {
            images: deleteImages,
          },
          isToken: true,
        });
      }
      const imagesData = await Promise.all(images.map((item) => {
        const formData = new FormData();
        formData.append('file', item);
        formData.append('folder', 'wizard-badges');
        return apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: formData,
          isToken: true,
        });
      }));
      const newImages = imagesData.map(({ data: { data: { url } } }) => url);
      const newSections = {
        orderSections: [{
          ...section,
          images: newImages,
        }],
      };
      await apiCall({
        type: 'PUT',
        url: URLS.wizardOrderSection,
        body: newSections,
        isToken: true,
      });
      notificationWithIcon('success', 'Wizard card updated');
      dispatch('getWizardSteps', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async deleteWizardCard({ dispatch }, payload) {
    try {
      const { id, type } = payload;
      await apiCall({
        type: 'DELETE',
        url: `${URLS.wizardOrderSection}s/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Wizard card deleted');
      dispatch('getWizardSteps', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async changeWizardStepDesign({ dispatch }, payload) {
    try {
      const { newStepValue, type } = payload;
      await apiCall({
        type: 'PUT',
        url: URLS.wizardBadgesStep,
        body: newStepValue,
        isToken: true,
      });
      notificationWithIcon('success', 'Wizard card design updated');
      dispatch('getWizardSteps', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async addWizardCard({ dispatch }, payload) {
    try {
      const { newSection, type } = payload;
      const { images, ...section } = newSection;
      const imagesData = await Promise.all(images.map((item) => {
        const formData = new FormData();
        formData.append('file', item);
        formData.append('folder', 'wizard-badges');
        return apiCall({
          type: 'POST',
          url: URLS.fileUpload,
          headers: { 'content-type': 'multipart/form-data' },
          body: formData,
          isToken: true,
        });
      }));
      const newImages = imagesData.map(({ data: { data: { url } } }) => url);
      const newValue = {
        ...section,
        images: newImages,
      };
      await apiCall({
        type: 'POST',
        url: URLS.wizardOrderSection,
        body: newValue,
        isToken: true,
      });
      notificationWithIcon('success', 'Wizard card created');
      dispatch('getWizardSteps', type);
    } catch (e) {
      const { response: { data: { message } } = { data: { message: e.message } } } = e;
      notificationWithIcon('error', message);
    }
  },
  async createWizardHelpCenter({ dispatch }, payload) {
    const {
      body,
      productName,
    } = payload;
    try {
      await apiCall({
        type: 'POST',
        url: URLS.wizardHelpCenter,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Hint updated');
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async editWizardHelpCenter({ dispatch }, payload) {
    const {
      body,
      productName,
      id,
    } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.wizardHelpCenter}/${id}`,
        body,
        isToken: true,
      });
      notificationWithIcon('success', 'Hint updated');
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteWizardHelpCenter({ dispatch }, payload) {
    const {
      id,
      productName,
    } = payload;
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.wizardHelpCenter}s/${id}`,
        isToken: true,
      });
      notificationWithIcon('success', 'Hint deleted');
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async createCategoriesWizardHelpCenter({ dispatch }, payload) {
    const {
      body,
      productName,
    } = payload;
    try {
      await apiCall({
        type: 'POST',
        url: URLS.wizardHelpCenterCategories,
        body,
        isToken: true,
      });
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async editCategoriesWizardHelpCenter({ dispatch }, payload) {
    const { categoryId, productName, body } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: `${URLS.wizardHelpCenterCategories}/${categoryId}`,
        body,
        isToken: true,
      });
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async deleteCategoriesWizardHelpCenter({ dispatch }, payload) {
    const {
      id,
      productName,
    } = payload;
    try {
      await apiCall({
        type: 'DELETE',
        url: `${URLS.wizardHelpCenterCategories}/${id}`,
        isToken: true,
      });
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
  async changePositionWizardHelpCenter({ dispatch }, payload) {
    const {
      body,
      productName,
    } = payload;
    try {
      await apiCall({
        type: 'PUT',
        url: URLS.wizardHelpCentersPosition,
        body,
        isToken: true,
      });
      dispatch('getWizardSteps', productName);
    } catch (err) {
      const { response: { data: { message } } = { data: { message: err.message } } } = err;
      notificationWithIcon('error', message);
    }
  },
};

export default actions;
